import {Component, OnInit, ViewChild, ViewEncapsulation, ElementRef} from '@angular/core';
import {state, style, transition, animate, trigger, AUTO_STYLE} from '@angular/animations';
import 'rxjs/add/operator/filter';
import { MenuItems } from '../../shared/menu-items/menu-items';
import {Router} from '@angular/router';
import {AuthService} from '../auth/guards/auth.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('slideOnOff', [
      state('on', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('off', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('on => off', animate('400ms ease-in-out')),
      transition('off => on', animate('400ms ease-in-out'))
    ]),
    trigger('mobileMenuTop', [
      state('no-block, void',
        style({
          overflow: 'hidden',
          height: '0px',
        })
      ),
      state('yes-block',
        style({
          height: AUTO_STYLE,
        })
      ),
      transition('no-block <=> yes-block', [
        animate('400ms ease-in-out')
      ])
    ])
  ]
})

export class AdminComponent implements OnInit {
  deviceType = 'desktop';
  verticalNavType = 'expanded';
  verticalEffect = 'shrink';
  chatToggle = 'out';
  chatInnerToggle = 'off';
  innerHeight: string;
  isScrolled = false;
  isCollapsedMobile = 'no-block';
  toggleOn = true;
  public loginUrl: any;
  showlogout = false;
  windowWidth: number;
  @ViewChild('searchFriends', {static: false}) search_friends: ElementRef;
  @ViewChild('toggleButton', {static: false}) toggle_button: ElementRef;
  @ViewChild('sideMenu', {static: false}) side_menu: ElementRef;
  config: any;
  mitems: any;
  UserFullName: string;
  fullName: string;
  sideitems: any;
  RejectedBadge;
  userDetails

  constructor(public menuItems: MenuItems, public router: Router, public authService: AuthService,) {
    this.authService.getAdminData().subscribe((data:any) => {
      this.userDetails = data.data
    })
    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + 'px';
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);
  //  window.localStorage.removeItem('isLoggedIn');
  }

  ngOnInit() {
    
  setInterval(() => {
    this.checksessiontimeout();
  }, 2000);   
    // this.getmenuItems();
   // this.UserFullName = JSON.parse(localStorage.getItem('supplierdetails')).Name;
    // window.addEventListener("beforeunload", function (e) {
    //   var confirmationMessage = "\o/";
    //   e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
    //   return confirmationMessage;  
    // });
  }

  //   public getmenuItems() {
  //   this.sideitems = [];
  //     this.menuItems.getAll().subscribe( data => {
  //       this.sideitems = data;
  //   // console.log(this.sideitems);
  //       this.mitems = this.sideitems.parentNodes;
  //     //  console.log(this.mitems);
  //     });
  // }

  logoutfunction(){
    if(this.showlogout == false){
    this.showlogout = true;}else{
      this.showlogout = false;
    }
  }

  onClickedOutside(e: Event) {
    if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
      this.toggleOn = true;
      this.verticalNavType = 'offcanvas';
    }
  }

  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    let reSizeFlag = true;
    if (this.deviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.deviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }

    if (reSizeFlag) {
      this.setMenuAttributs(this.windowWidth);
    }
  }

  public checksessiontimeout() {
    this.loginUrl = 'auth/login';
    const now: any = new Date().getTime();
   // console.log(now);
    const setupTime: any = localStorage.getItem('setupTime');
  //  console.log(now - setupTime);
    if (setupTime == null) {
        // localStorage.setItem('setupTime', now);
    } else {
        if (now - setupTime > 90 * 60 * 1000) {
            //  console.log(now - setupTime)
       //     console.log("control coming")
            sessionStorage.clear();
            localStorage.clear();
            swal.fire('Session timeout', 'Please login again', 'warning');
            this.router.navigate([this.loginUrl]);
        }
    }
}

  setMenuAttributs(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.deviceType = 'tablet';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'push';
    } else if (windowWidth < 768) {
      this.deviceType = 'mobile';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else {
      this.deviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
    }
  }

  searchFriendList(event) {
    const search = (this.search_friends.nativeElement.value).toLowerCase();
    let search_input: string;
    let search_parent: any;
    const friendList = document.querySelectorAll('.userlist-box .media-body .chat-header');
    Array.prototype.forEach.call(friendList, function(elements, index) {
      search_input = (elements.innerHTML).toLowerCase();
      search_parent = (elements.parentNode).parentNode;
      if (search_input.indexOf(search) !== -1) {
        search_parent.classList.add('show');
        search_parent.classList.remove('hide');
      } else {
        search_parent.classList.add('hide');
        search_parent.classList.remove('show');
      }
    });
  }

  toggleChat() {
    this.chatToggle = this.chatToggle === 'out' ? 'in' : 'out';
  }

  toggleChatInner() {
    this.chatInnerToggle = this.chatInnerToggle === 'off' ? 'on' : 'off';
  }

  toggleOpened() {
    if (this.windowWidth < 768) {
      this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    } else {
      this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
    }
  }

  onMobileMenu() {
    this.isCollapsedMobile = this.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
  }

  onScroll(event) {
    this.isScrolled = false;
  }

  // logout

  logout(): void {
    console.log("logout btn is working")
   this.authService.logout();
   this.router.navigate(['/auth/login']);
  }

}
